import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../util/layout';
import logo from '../img/logo.png';
import bannerLogo from '../img/2.png';
import whyLogo from '../img/3.png';
import bscLogo from '../img/partner/bsc.png';
import santanderLogo from '../img/partner/santander.png';
import fdlLogo from '../img/partner/fdl.png';
import pawsomeLogo from '../img/partner/pawesome.png';
import barclaysLogo from '../img/partner/barclays.png';
import ebeezeLogo from '../img/partner/e-beeze.png';
import lloydsLogo from '../img/partner/lloyds.png';
import sucroliqLogo from '../img/partner/sucroliq.png';
import cranfieldLogo from '../img/partner/cranfield.png';
import keystoneLogo from '../img/partner/keystone.png';
import neopostLogo from '../img/partner/neopost.png';
import oeeLogo from '../img/partner/oee.png';
import marshLogo from '../img/partner/marsh.png';
import fosLogo from '../img/partner/fos.png';
import lsbuLogo from '../img/partner/lsbu.png';
import nhsLogo from '../img/partner/nhs.png';
import dtLogo from '../img/partner/dt.png';
import centricaLogo from '../img/partner/centrica.png';
import agodaLogo from '../img/partner/agoda.png';
import bizbrellaLogo from '../img/partner/bizbrella.png';
import tescoLogo from '../img/partner/tesco.png';
import thumbnail from '../img/thumbnail.png';
import { confirmAlert } from 'react-confirm-alert';
import ReactPlayer from 'react-player';
import AliceCarousel from 'react-alice-carousel';

function Player(props){
    
    const padding = 80;
    const percentage = (num, per) =>{
      return (num/100)*per;
    }

    const iw = percentage(window.innerWidth, padding);
    const ih = iw > window.innerHeight ? percentage(window.innerHeight, padding) : iw;
    const [width, setWidth] = useState(iw);
    const [height, setHeight] = useState(ih);

    const updateWindowDimensions = () => {
        const w = percentage(window.innerWidth, padding);
        const h = w > window.innerHeight ? percentage(window.innerHeight, padding) : w;

        setWidth(w);
        setHeight(h);
    }

    useEffect(() => {
        updateWindowDimensions();
        window.addEventListener("resize", updateWindowDimensions);
        return () => {
            window.removeEventListener('resize', updateWindowDimensions);
        }
    },  []);

    return (
        <div className='custom-ui player' style={{width: `${width}px`, height: `${height}px`}}>
            <div className="close"><a className="btn-close btn-close-white" aria-label="Close" href="#" onClick={(e) =>{e.preventDefault(); props.onClose();}}>X</a></div>
            <div className="video" style={{width: "100%", height: "100%"}}>
                <ReactPlayer width="100%" height="100%" playing={true} controls={true} pip={false} url={props.url} />
            </div>
        </div>
    );
}

const Home = () => {
    const handleDragStart = (e) => e.preventDefault();
    const partners = [
        <div className='image'><img src={pawsomeLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={barclaysLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={ebeezeLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={lloydsLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={sucroliqLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={cranfieldLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={keystoneLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={neopostLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={oeeLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={marshLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={fosLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={lsbuLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={nhsLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={dtLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={centricaLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={agodaLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={bizbrellaLogo} onDragStart={handleDragStart} role="presentation" /></div>,
        <div className='image'><img src={tescoLogo} onDragStart={handleDragStart} role="presentation" /></div>,
    ];

    const partnersResponsive = {
        0: { items: 2 },
        568: { items: 3 },
        1024: { items: 4 },
    };

	return(
        <Layout title="Home">
            <div className="page-header--image" data-padding="" data-overlay="">
                <div className="imagebg">
                    <img src={bannerLogo} alt="" style={{opacity: 1}} />
                </div>
                <div className="container">
                    <div className="row">
                        <div data-aos="fade-up" className="col-12 col-lg-6 col-xl-5 aos-init aos-animate">
                            <div className="sectiontitle-element--light">
                                <h1 className="big">Maximise office mojo, minimise costs</h1>
                                <p>All your digital office needs and much more, for the price of a coffee… things can only get better.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <section data-padding="">
                    <div className="container">
                        <div data-aos="fade-up" className="row aos-init aos-animate" data-padding="xstop">
                            <div className="col-12">
                                <div className="sectiontitle-element--center">
                                    <span className="toptitle">What We Do</span>
                                    <h2>We provide all your online digital office needs in one place to reduce costs</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row" data-padding="xstop">
                            <div data-aos="fade-up" data-aos-delay="100" className="col-12 col-md-4 aos-init aos-animate">
                                <div className="icon-element--round--box--border">
                                    <div className="info">
                                        <div className="icon"><i className="fa fa-pencil" aria-hidden="true"></i></div>
                                        <div className="text">
                                            <h6>eSignatures</h6>
                                            <p>Send agreements to multiple people for review and signing with full data collection and integration</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="200" className="col-12 col-md-4 aos-init aos-animate">
                                <div className="icon-element--round--box--border">
                                    <div className="info">
                                        <div className="icon"><i className="fa fa-sitemap" aria-hidden="true"></i></div>
                                        <div className="text">
                                            <h6>Automated Workflows</h6>
                                            <p>Create automated tasks and processes allowing your customers and staff to instantly interact with each other</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div data-aos="fade-up" data-aos-delay="300" className="col-12 col-md-4 aos-init aos-animate">
                                <div className="icon-element--round--box--border">
                                    <div className="info">
                                        <div className="icon"><i className="fa fa-user-secret" aria-hidden="true"></i></div>
                                        <div className="text">
                                            <h6>On Premise</h6>
                                            <p>You can now have your fully private and on-premise eSignature platform with 100% data ownership</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section data-aos="zoom-in" data-padding="bottom" className="aos-init aos-animate">
                    <div className="container">
                        <div className="row" data-padding="xs">
                            <div className="col-12">
                                <div className="separator-element--lg--center"></div>
                            </div>
                        </div>
                    </div>
                </section>
                <section data-padding="bottom">
                    <div className="container">
                        <div className="row align-items-lg-center">
                            <div data-aos="zoom-in" className="col-12 col-lg-5 aos-init aos-animate">
                                <div className="square-element">
                                    <div className="info">
                                        <div className="image">
                                            <img src={whyLogo} alt="" style={{opacity: 1}} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div data-aos="fade-in" data-aos-delay="200" className="col-12 col-lg-6 aos-init aos-animate">
                                <div className="sectiontitle-element">
                                    <span className="toptitle">Why Us</span>
                                    <h2>AWS and SignTech Paperless Solutions partnered to change the game for you.</h2>
                                    <p>The Amazon Digital Office has been developed with AWS to give you significant advantage over your competition. You now have many services on one platform, including eSignatures, automated workflows and integration with other systems such as SalesForce.com all for a single affordable price.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section data-padding="top" data-bg="grey">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="sectiontitle-element--inline align-items-md-end">
                                    <div className="wrapper">
                                        <span className="toptitle">Use Cases</span>
                                        <h2>How companies are benefiting</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" data-padding="coltop">
                            <div className="col-12">
                                <div id="owl-carousel-main">                                        
                                    <div className="square-element--project">
                                        <div className="info">
                                            <div className="image">
                                                <img className="owl-lazy" src={bscLogo} alt="" style={{opacity: 1}} />
                                                <div className="icon--br--square--secondary"><i className="fa fa-plus" aria-hidden="true"></i></div>
                                            </div>
                                            <div className="text">
                                                <h6>BSC Rwanda</h6>
                                                <p>Engineers</p>
                                            </div>
                                        </div>
                                        <Link to="/bsc-rwanda" className="link"></Link>
                                    </div>
                                    <div className="square-element--project">
                                        <div className="info">
                                            <div className="image" style={{background: '#ec0000'}}>
                                                <img className="owl-lazy" src={santanderLogo} alt="" style={{opacity: 1}} />
                                                <div className="icon--br--square--secondary"><i className="fa fa-plus" aria-hidden="true"></i></div>
                                            </div>
                                            <div className="text">
                                                <h6>Santander Paper-Free Programme</h6>
                                                <p>Banking</p>
                                            </div>
                                        </div>
                                        <Link to="/santander" className="link"></Link>
                                    </div>
                                    <div className="square-element--project">
                                        <div className="info">
                                            <div className="image">
                                                <img className="owl-lazy" src={fdlLogo} alt="" style={{opacity: 1}} />
                                                <div className="icon--br--square--secondary"><i className="fa fa-plus" aria-hidden="true"></i></div>
                                            </div>
                                            <div className="text">
                                                <h6>FDL Engineers Go Digital</h6>
                                                <p>SME</p>
                                            </div>
                                        </div>
                                        <Link to="/fdl" className="link"></Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 partners" data-padding="xstop">
                                <AliceCarousel 
                                    items={partners}
                                    duration={400}
                                    autoPlayInterval={2000}
                                    autoPlay
                                    infinite
                                    mouseTracking
                                    buttonsDisabled={true}
                                    controlsStrategy="alternate"
                                    responsive={partnersResponsive}
                                />
                            </div>
                        </div>
                    </div>
                </section>
                <section data-bg-top="grey" data-padding="">
                    <div className="container">
                        <div className="row">
                            <div data-aos="fade-up" data-aos-delay="100" className="col-12 aos-init aos-animate">
                                <div className="rectangle-element--caption--center--vertical--big">
                                    <div className="info">
                                        <div className="image">
                                            <img src={thumbnail} alt="" style={{opacity: 1}} />
                                            <div className="icon--xl--white--shadow--round--white"><i className="fas fa-play"></i></div>
                                        </div>
                                    </div>
                                    <a 
                                        className="popup-youtube link yt-video"
                                        href="#" 
                                        onClick={(e) => {
                                            e.preventDefault();
                                            confirmAlert({
                                                customUI: ({ onClose }) => {
                                                    return (
                                                        <Player url="https://www.youtube.com/watch?v=cyTX_7SdPIU" onClose={onClose} />
                                                    );
                                                },
                                                closeOnClickOutside: false
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section data-padding="" data-bg="template">
                    <div className="container">
                        <div className="row align-items-md-center">
                            <div className="col-md-6 aos-init">
                                <div className="icon-element--testimonial">
                                    <div className="info">
                                        <div className="text">
                                            <p>“SignTech’s digital workflow solutions have been critical to our business operations. We have realized significant cost savings and most recently we have managed to continue working seamlessly the imposed lockdowns…”
                                            </p>
                                            <span className="author">Christian Muhirwa <em className="meta">CEO – Broadband Systems Corporation</em></span>
                                            <img className="logo" src={bscLogo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5 offset-md-1 aos-init">
                                <div className="wrapimage-element--square">
                                    <img src={bscLogo} alt="" style={{opacity: 1, background: 'white', padding: '20%'}} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    );
}

export default Home;